import React from "react";

import { Button } from "../ui/button";
import { PageContainer } from "./PageContainer";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

export const ResultPage: React.FC<{
	children: React.ReactNode;
	onPressBack: () => void;
}> = ({ children, onPressBack }) => {
	return (
		<PageContainer>
			<div className="flex-1 flex flex-col min-h-0">
				{children}
				<div className="flex flex-col md:flex-row p-3 gap-2 md:gap-6 flex-shrink-0 border-t justify-between items-center">
					<Button
						className="w-full md:flex-1"
						onClick={onPressBack}
						variant="secondary"
					>
						<ArrowLeftIcon className="size-4" /> Analyze Another Text
					</Button>
				</div>
			</div>
		</PageContainer>
	);
};
